import React, {useReducer} from "react";
import {Col, Row, Card} from "antd";
import videoContentsApi from '@api/video-content'

import {useEffect, useState} from "react";
import VideoContentsReportSearch from '@components/video-contents/Report/Search';
import ViewChart from '@components/video-contents/Report/ViewChart';
import PurchaseChart from '@components/video-contents/Report/PurchaseChart';


const initialState = {
  params: {},
  viewReport: [],
  purchaseReport: []
};

function reducer(state, action) {
  switch (action.type) {
    case 'SET_PARAMS':
      return {...state, params: action.payload};
    
    case 'FETCHED_VIEW_DATA':
      return {...state, viewReport: action.payload};
    
    case 'FETCHED_PURCHASE_DATA':
      return {...state, purchaseReport: action.payload};
    
    default:
      return state;
  }
}

function VideoContentReportPage(props) {
  const {id} = props.match.params;
  const [state, dispatch] = useReducer(reducer, initialState);
  
  useEffect(() => {
    fetchData()
  }, []);
  
  const fetchData = (params = {}) => {
    dispatch({type : "SET_PARAMS", payload: params})
    
    videoContentsApi.getItemViewReport({
        params: {id, ...params}
      })
      .then(({data, meta}) => {
        dispatch({type : "FETCHED_VIEW_DATA", payload: data || []})
      })
      .catch()
    
    videoContentsApi.getItemPurchaseReport({
        params: {id, ...params, count: 1000}
      })
      .then(({data, meta}) => {
        dispatch({type : "FETCHED_PURCHASE_DATA", payload: data || []})
      })
      .catch()
  };
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <VideoContentsReportSearch search={fetchData}/>
        </Card>
      </Col>
      <Col span={24}>
        {/*{state.data.length > 0 && (*/}
        <Row gutter={12}>
          <Col span={12}>
            <ViewChart interval={state.params.interval} data={state.viewReport}/>
          </Col>
          
          <Col span={12}>
            <PurchaseChart data={state.purchaseReport}/>
          </Col>
        </Row>
        {/*)}*/}
      </Col>
    </Row>
  )
}

export default VideoContentReportPage;

